module.exports = __webpack_public_path__ + "static/media/organizationalAssessments.0cb02b36.svg";